import axiosInstance from "../../../helpers/api";

export const getAllAdminSections = (body) => {
  return axiosInstance.get("/superadmin/sections", body);
};

export const editAdminSections = (formData) => {
  return axiosInstance.post(
    `/superadmin/sections/${formData.id}`,
    formData.formData
  );
};

export const createAdminSections = (formData) => {
  return axiosInstance.post("/superadmin/sections", formData);
};

export const deleteAdminSection = (id) => {
  return axiosInstance.delete(`/superadmin/sections/${id}`);
};
